<app-header></app-header>
<app-botao-chat></app-botao-chat>
<app-alert-cancelar-pedido [alertCancelarPedido]="showAlertCancelarPedido" [dadosPedido]="dadosResumoPedido"
  [dadosCancelamento]="cancelarPedido" (alertCancelarPedidoFechou)="eventoAlertCancelarPedido($event)"
(alertCancelarPedidoConfirmou)="eventoAlertConfirmarCancelamento($event)"></app-alert-cancelar-pedido>
<app-alert-imprimir-recibo [dadosPedido]="dadosResumoPedido" [alertImprimirRecibo]="showAlertImprimirRecibo"
  [idPedido]="idPedido" (alertCancelarPedidoFechou)="eventoAlertCancelarPedido($event)"
(alertImprimirReciboFechou)="fecharAlertImprimirRecibo()"></app-alert-imprimir-recibo>

<div class="container py-4">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <app-breadcrumb></app-breadcrumb>
        <h1 class="titulo">Consulta de pedido</h1>
        <div>
          @if (dadosResumoPedido) {
            <p class="info-empresa">{{dadosResumoPedido.nomeEmpresa}} <br>
            {{dadosResumoPedido.cnpj | cnpj}}</p>
          }
        </div>
        <!-- NAVEGAÇÃO DAS ABAS DO DETALHAMENTO DO PEDIDO -->
        <ul class="nav nav-tabs border-0 mb-5" id="myTab">
          <li class="nav-item">
            <a
              class="nav-link active"
              id="resumoTab"
              data-bs-toggle="tab"
              href="#resumo"
              aria-controls="resumo"
              style="padding-left: 0px !important;"
            >Resumo</a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              id="taxaOperadoraTab"
              data-bs-toggle="tab"
              href="#taxaOperadora"
              aria-controls="taxaOperadora"
              (click)="consultaTaxasOperadoresPedido()"
              (keydown.enter)="consultaTaxasOperadoresPedido()"
            >Taxa de operadora</a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              id="listaUsuariosTab"
              data-bs-toggle="tab"
              href="#listaUsuarios"
              aria-controls="listaUsuarios"
              [ngClass]="{ 'disabled': pedidoPapel }"
              (click)="consultaListaUsuariosPedido()"
              (keydown.enter)="consultaListaUsuariosPedido()"
            >Lista de usuários</a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              id="recargaCertaTab"
              data-bs-toggle="tab"
              href="#recargaCerta"
              aria-controls="listaUsuarios"
              [ngClass]="{ 'disabled': !recargaCerta || !processado }"
            >Recarga certa</a>
          </li>
        </ul>

        <!-- Conteúdo das TABS (navegação entre as abas) -->
        <div class="tab-content" id="myTabContent">
          <!-- CONTEÚDO DA ABA DE ENDEREÇO -->
          <div class="tab-pane fade show active" id="resumo" role="tabpanel" aria-labelledby="resumoTab">
            <app-resumo [dadosResumo]="dadosResumoPedido" [pedidoPapel]="pedidoPapel"></app-resumo>
          </div>
          <!-- CONTEÚDO DA ABA DE PRODUTO -->
          <div class="tab-pane fade" id="taxaOperadora" role="tabpanel" aria-labelledby="taxaOperadoraTab">
            <app-taxa-operadora [dadosTaxasOperadoras]="dadosTaxasOperadorasPedido"></app-taxa-operadora>
          </div>
          <div class="tab-pane fade" id="listaUsuarios" role="tabpanel" aria-labelledby="listaUsuariosTab">
            <app-lista-usuarios [dadosListaUsuarios]="dadosListaUsuariosPedido"></app-lista-usuarios>
          </div>
          <div class="tab-pane fade" id="recargaCerta" role="tabpanel" aria-labelledby="recargaCertaTab">
            <app-recarga-certa [idPedido]="idPedido" ></app-recarga-certa>
          </div>
        </div>

        @if (dadosResumoPedido) {
          <div class="footer-card">
            <button class="botao-outline" id="btnVoltar" (click)="goBackPage()">VOLTAR</button>
            <button class="botao-outline" id="btnImprimirRecibo" (click)="imprimirReciboPdf()"
              [ngClass]="$safeNavigationMigration((usuarioPermissaoService.cssPorPermissoes$ | async)?.PedidosListarPedidos?.Imprimir)">IMPRIMIR
            RECIBO</button>
            <button class="botao-outline" id="btnRelatorioPdf" (click)="gerarRelatorioPdf()"
              [ngClass]="$safeNavigationMigration((usuarioPermissaoService.cssPorPermissoes$ | async)?.PedidosListarPedidos?.Imprimir)">RELATÓRIO
            PDF</button>
            <button class="botao-outline" id="btnRelatorioXls" (click)="gerarRelatorioXls()"
              [ngClass]="$safeNavigationMigration((usuarioPermissaoService.cssPorPermissoes$ | async)?.PedidosListarPedidos?.Imprimir)">RELATÓRIO
            XLS</button>
            <button class="botao-outline" id="btnRelatorioRc" (click)='getRelatorio()' [ngClass]="{ 'disabled': !recargaCerta || !processado }" [disabled]="!recargaCerta || !processado">RELATÓRIO RC</button>
            <button class="botao-outline" id="btnCancelarRc" style="color: #D7454D; border-color: #D7454D; max-width: 190px; width: auto;"
              (click)="exibirAlertCancelarPedido()"
            [disabled]="!dadosResumoPedido || !('PedidosListarPedidos' | usuarioPermissao:'Excluir' | async) || statusPedido === 'Pago' || statusPedido === 'Cancelado' " [ngClass]="{
              disabled: !dadosResumoPedido || !('PedidosListarPedidos' | usuarioPermissao:'Excluir' | async) || statusPedido === 'Pago' || statusPedido === 'Cancelado' }">
            CANCELAR PEDIDO</button>
          </div>
        }

      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
